
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.037 0a.938.938 0 00-.69.307L.272 5.794a1.05 1.05 0 000 1.413l5.073 5.485a.93.93 0 001.363.021c.38-.39.39-1.03.018-1.432L2.297 6.5l4.43-4.78A1.051 1.051 0 006.71.287.933.933 0 006.037 0z","fill":"#2E50D4"}})])
          )
        }
      }
    